import styled from 'styled-components'

import InlineCenterLoader from '../../../../components/Loader/InlineCenterLoader'
import { jackpotVerticalMediaQuery } from '../../../JackpotBox/styles/jackpotVerticalMediaQuery'

const JackpotsWidgetLoader = styled(InlineCenterLoader)`
  height: 5rem;

  ${jackpotVerticalMediaQuery`
    height: 6rem;
  `}
`

export default JackpotsWidgetLoader
